export class BOToothStateDetailToothFace{
  id?:number;
  toothStateDetailId:number;
  toothFaceId:number;
  toothStateId:number;
  color?:string;
  strokeColor?:string;
}


